<template>
    <div class="secret">
        <div
            v-if="show"
            class="secret-key"
        >
            <svg width="22px" height="17px" viewBox="0 0 22 17" class="right-10 svg-btn" @click="toggle">
                <defs>
                    <linearGradient x1="79.7940341%" y1="35.2910073%" x2="8.51004464%" y2="70.2479339%" id="linearGradient">
                        <stop stop-color="#F59C07" offset="0%" />
                        <stop stop-color="#F57507" offset="100%" />
                    </linearGradient>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="colorfull" transform="translate(-446.000000, -390.000000)">
                        <g transform="translate(30.000000, 220.000000)">
                            <g transform="translate(0.000000, 149.000000)">
                                <g transform="translate(416.000000, 21.000000)">
                                    <path d="M6.28893553,10.659803 L4.521173,13.7216575 C1.9778096,11.9526167 0.341496187,9.77053682 0.22480739,9.59375 C-0.0749357967,9.195313 -0.0749357967,8.804688 0.22480739,8.40625 C0.423339006,8.105469 5.02070237,2 11,2 C11.0956897,2 11.1910255,2.00156368 11.2859949,2.00464224 L10.0875469,4.08041508 C7.74572761,4.49984695 6.01725197,6.51270623 6.01725197,9 C6.01725197,9.58428254 6.11263144,10.1423852 6.28893553,10.659803 Z M11.2933849,13.9918425 C13.9431752,13.8439227 15.982748,11.7018738 15.982748,9 C15.982748,8.1890902 15.799029,7.42860787 15.4702331,6.75732907 L17.0630827,3.99843276 C19.8428249,5.80825383 21.6522633,8.22000867 21.7751926,8.40625 C22.0749358,8.804688 22.0749358,9.195313 21.7751926,9.59375 C21.576661,9.894531 16.9792976,16 11,16 C10.7158119,16 10.4347456,15.9862079 10.1571249,15.9599024 L11.2933849,13.9918425 Z" id="Icons/Eye_gray" fill-rule="nonzero" />
                                    <rect id="Rectangle" transform="translate(11.000000, 8.500000) rotate(-330.000000) translate(-11.000000, -8.500000) " x="10" y="0" width="2" height="17" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <span>{{ data }}</span>
            <input
                type="text"
                :value="data"
                ref="clipboard"
                class="hidden-input"
            >
            <svg width="17px" height="20px" viewBox="0 0 17 20" class="left-10 svg-btn" @click="copy">
                <defs>
                    <linearGradient x1="79.7940341%" y1="35.2910073%" x2="8.51004464%" y2="70.2479339%" id="linearGradient">
                        <stop stop-color="#F59C07" offset="0%" />
                        <stop stop-color="#F57507" offset="100%" />
                    </linearGradient>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="colorfull" transform="translate(-846.000000, -389.000000)">
                        <g transform="translate(30.000000, 220.000000)">
                            <g transform="translate(0.000000, 149.000000)">
                                <g transform="translate(816.000000, 20.000000)">
                                    <path d="M2,0 C0.898438,0 0,0.898438 0,2 L0,15 L2,15 L2,2 L12,2 L12,0 L2,0 Z M6,4 C4.898438,4 4,4.898438 4,6 L4,18 C4,19.101563 4.898438,20 6,20 L15,20 C16.101563,20 17,19.101563 17,18 L17,6 C17,4.898438 16.101563,4 15,4 L6,4 Z M6,6 L15,6 L15,18 L6,18 L6,6 Z" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>

        <div
            v-if="!show"
            @click="toggle"
            class="toggle-secret-btn"
        >
            <svg width="22px" height="14px" viewBox="0 0 22 14" class="right-10">
                <defs>
                    <linearGradient x1="79.7940341%" y1="35.2910073%" x2="8.51004464%" y2="70.2479339%" id="linearGradient">
                        <stop stop-color="#F59C07" offset="0%" />
                        <stop stop-color="#F57507" offset="100%" />
                    </linearGradient>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g class="colorfull" transform="translate(-446.000000, -452.000000)" fill-rule="nonzero">
                        <g transform="translate(30.000000, 220.000000)">
                            <g transform="translate(20.000000, 229.000000)">
                                <g transform="translate(396.000000, 3.000000)">
                                    <path d="M11,0 C5.02070237,0 0.423339006,6.105469 0.22480739,6.40625 C-0.0749357967,6.804688 -0.0749357967,7.195313 0.22480739,7.59375 C0.423339006,7.894531 5.02070237,14 11,14 C16.9792976,14 21.576661,7.894531 21.7751926,7.59375 C22.0749358,7.195313 22.0749358,6.804688 21.7751926,6.40625 C21.576661,6.105469 16.9792976,0 11,0 Z M11,2 C13.7911172,2 15.982748,4.199219 15.982748,7 C15.982748,9.800781 13.7911172,12 11,12 C8.2088828,12 6.01725197,9.800781 6.01725197,7 C6.01725197,4.199219 8.2088828,2 11,2 Z M11,4.5 C9.62585177,4.5 8.50862599,5.621094 8.50862599,7 C8.50862599,8.378906 9.62585177,9.5 11,9.5 C12.3741482,9.5 13.491374,8.378906 13.491374,7 C13.491374,5.621094 12.3741482,4.5 11,4.5 Z" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
            <span>{{ $t('clients.show') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Secret',

    components: {},

    props: {
        data: {
            type: String,
            default: '',
            require: true,
        }
    },

    data: () => {
        return {
            show: false,
        }
    },

    computed: {},

    mounted() {},

    methods: {
        toggle() {
            this.show = !this.show
        },

        copy() {
            const text = this.$refs.clipboard
            text.select()
            document.execCommand('copy')
        },
    },
}
</script>

<style lang='scss' scoped>
.secret {
    overflow: hidden;
    position: relative;

    svg {
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;

        .colorfull {
            fill: #838383;
        }

        &:hover {
            .colorfull {
                fill: url(#linearGradient);
            }
        }
    }
}

.toggle-secret-btn {
    cursor: pointer;
    user-select: none;

    svg {
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;

        .colorfull {
            fill: #838383;
        }
    }

    span {
        vertical-align: middle;
    }

    &:hover {
        color: rgba(245, 125, 7, 1);

        svg {
            .colorfull {
                fill: url(#linearGradient);
            }
        }
    }
}

.secret-key {
    span {
        vertical-align: middle;
        cursor: text;
    }
}

.right-10 {
    margin-right: 10px;
}

.left-10 {
    margin-left: 10px;
}

.svg-btn {
    cursor: pointer;
}

.hidden-input {
    position: absolute;
    top: -100000000px;
    left: -1000000000px;
    opacity: 0;
}
</style>
